<template>
  <div class="app__content view-home">
    <section class="section">
      <div class="section__wrapper">
        <div class="section__content section__copy">

          <p>Britain, Take A Bow is a generative artwork that sequences vignettes of British life, captured by a collaboration of filmmakers and artists across the UK, as we hurtle towards Brexit...</p>
          
          <p class="mb-6">Each 'play' is a unique experience - no two viewings will ever be the same</p>
          
          <button class="button mr-2" @click="goToVideo">Play...</button>
          <router-link :to="{ name: 'view-about' }">About</router-link>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader';

export default {
  name: 'Home',
  methods: {
    goToVideo() {
      this.$router.push({ name: 'view-video' });
    },
  },
  components: {
    AppHeader,
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// home.vue?380e0e9e